// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { print } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-print': IconPrint;
    }
}

/**
 * The icon component for the 'print' icon
 */
export class IconPrint extends IconSvg {
    public constructor() {
        super(print);
    }
}

registerIconSvg('icon-print', IconPrint);
export const iconPrintTag = 'nimble-icon-print';
